/*    
<summary>
  This functional component "AddDevicePopupHOC" provides props to the child component.
  1. State "showDeleteAllFilesPopup" that manages the show/hide of pop up
  2. Function "deleteAllFilesToggleHandler" to toggle the show/hide popup state "showDeleteAllFilesPopup"
  Developer:Chandan Singh, Created Date:30-April-2026
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const DeleteAllFilesPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDeleteAllFilesPopup, setShowDeleteAllFilesPopup] =
      useState<boolean>(false);

    const deleteAllFilesToggleHandler = () => {
      setShowDeleteAllFilesPopup(!showDeleteAllFilesPopup);
    };

    return (
      <Component
        showDeleteAllFilesPopup={showDeleteAllFilesPopup}
        deleteAllFilesToggleHandler={deleteAllFilesToggleHandler}
        {...props}
      />
    );
  };

export default DeleteAllFilesPopupHOC;
